import React,{Component} from 'react';

import Wrapper from '../Wrapper';

import Presskit from './Presskit';

import './Contact.less';

const ContactBlock = ({res,personen,title}) => {
  return (
    <ul className={`contact-block ${res}`}>
    <li><h3>{title}</h3></li>
    {
      personen.map(person => <span key={person.name}><li><h4>{person.name}</h4></li><li><a href={`mailto:${person.email}`} >{person.email}</a></li></span>)
    }
    </ul>
  )
}

const Contact = ({res,id,data}) => {
  const {contact_blocks} = data;
  return (
    <Wrapper title="Kontakt" style={{marginBottom:0}} res={res} id={id}>
   <div className={`contacts ${res}`} >
   {
     contact_blocks.map((block,idx) => <ContactBlock key={idx} {...block} res={res}/>)
   }
    </div>
    <Presskit res={res} data={data} />
    </Wrapper>
  )
}

export default Contact



// WEBPACK FOOTER //
// ./src/components/sections/Contact.js